import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../../util/withRouter';
import { FormattedMessage } from 'react-intl';
import { Link, NavLink } from 'react-router-dom';
import windowSize from '../../../../util/windowSize';
import { Button, Navbar, Nav, Container, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toggleNavigationShown, toggleNavigationMenuOpened } from '../../AppActions';
import { trackMenuScrollCheck } from '../../../../util/mixpanel';
import { translate } from '../../../../util/translate';
import { PERMISSIONS } from '../../../../util/permissions';

const menuScrollSent = { menu_scrolled: false, menu_not_scrolled: false };

// Import Style
import './Navigation.scss';

import logo from '../../../../assets/img/nave-logo-white.svg';
import processImprovementIcon from '../img/icon-nav/process-improvement.svg';
import flowMetricsIcon from '../img/icon-nav/flow-metrics.svg';
import cfdIcon from '../img/icon-nav/CFD.svg';
import scatterplotIcon from '../img/icon-nav/CTS.svg';
import breakdownIcon from '../img/icon-nav/CTB.svg';
import cycleTimeHistogramIcon from '../img/icon-nav/CTH.svg';
import agingIcon from '../img/icon-nav/AC.svg';
import runChartIcon from '../img/icon-nav/TRC.svg';
import throughputHistogramIcon from '../img/icon-nav/TH.svg';
import flowEfficiencyIcon from '../img/icon-nav/FEC.svg';
import dueDatesIcon from '../img/icon-nav/DDP.svg';
import deliveryDateIcon from '../img/icon-nav/MC-01.svg';
import numberOfTasksIcon from '../img/icon-nav/MC-02.svg';
import forecastingIcon from '../img/icon-nav/continues-forecasting.svg';
import valueStreamsIcon from '../img/icon-nav/executive-overview.svg';
import portfoliosIcon from '../img/icon-nav/ed_overview.svg';

const RAIL_MAX_WIDTH = 1200;
const PHONE_MAX_WIDTH = 600;

const CHARTS = [
  { path: 'cfd', messageId: 'cfd', icon: cfdIcon },
  { path: 'ctsp', messageId: 'ctsp', icon: scatterplotIcon },
  { path: 'ctb', messageId: 'ctb', label: 'Cycle Time Breakdown', icon: breakdownIcon },
  { path: 'cth', messageId: 'cth', icon: cycleTimeHistogramIcon },
  { path: 'cta', messageId: 'cta', icon: agingIcon },
  { path: 'trc', messageId: 'throughput', icon: runChartIcon },
  { path: 'th', messageId: 'throughputHistogram', icon: throughputHistogramIcon },
  { path: 'fe', messageId: 'flowEfficiency', label: 'Flow Efficiency', icon: flowEfficiencyIcon },
  { path: 'ddp', messageId: 'dueDatePerf', label: 'Due Date Performance', icon: dueDatesIcon },
  { path: 'montecarlodates', messageId: 'monteCarloDate', icon: deliveryDateIcon },
  { path: 'montecarlotasks', messageId: 'monteCarloTasks', icon: numberOfTasksIcon },
  { path: 'forecasts', messageId: 'continuesForecasting', icon: forecastingIcon },
];

import _ from 'lodash';

export class Navigation extends Component {
  static defaultProps = {
    showLinks: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
    this.lastVisit = {};
    try {
      this.lastVisit = JSON.parse(window.localStorage.getItem('navigation')) || {};
    } catch (err) {}
  }

  handleHover(){
    if (this.state.isLocked) return
    this.setState(prevState => ({
      isLocked: prevState.isHovered,
      isHovered: !prevState.isHovered
    }), () => setTimeout(() => this.setState({ isLocked: false }), 100));
  }

  isActive(path, search) {
    return this.props && this.props.location && this.props.location.search === search
    && (this.props.location.pathname === path || this.props.location.pathname === path + '/');
  }

  componentDidMount() {
    if (this.props.navigationShown) {
      document.addEventListener('mousedown', this.handleOverlayOutsideClick);
    }
    const navigation = window && window.localStorage && window.localStorage.getItem('navigation');
    if (navigation) {
      let value;
      try {
        value = JSON.parse(navigation);
      } catch (err) {}
      if (value) {
        this.props.toggleNavigationShown(value.navigationShown || false);
        this.props.toggleNavigationMenuOpened(value.navigationMenuOpened || false);
      }
    } else {
      this.props.toggleNavigationShown(false);
      this.props.toggleNavigationMenuOpened(false);
    }

    this.menuScrollHandler = (e) => {
      try {
        const menu = document.querySelector('.navigation-inner .navbar-nav');
        if (menuScrollSent.menu_scrolled && menuScrollSent.menu_not_scrolled) return;
        if (!menu || !menu.contains(e.target) || e.deltaY === 0) return;
        if (menu.scrollHeight <= menu.clientHeight) return;

        const startTop = menu.scrollTop;
        const info = {
          delta_x: e.deltaX,
          delta_y: e.deltaY,
          delta_mode: e.deltaMode,
          default_prevented: e.defaultPrevented,
          target: e.target.tagName.toLowerCase() + '.' + Array.from(e.target.classList).join('.'),
          menu_state: this.props.navigationMenuOpened ? 'wide' : 'narrow',
          window_inner_width: window.innerWidth,
          window_inner_height: window.innerHeight,
          device_pixel_ratio: window.devicePixelRatio,
          user_agent: navigator.userAgent,
        };

        setTimeout(() => {
          try {
            const outcome = menu.scrollTop === startTop ? 'menu_not_scrolled' : 'menu_scrolled';
            if (menuScrollSent[outcome]) return;
            menuScrollSent[outcome] = true;
            trackMenuScrollCheck({ ...info, outcome });
          } catch (err) {}
        }, 300);
      } catch (err) {}
    };
    document.addEventListener('wheel', this.menuScrollHandler, { passive: true });
  }

  componentWillUnmount() {
    clearTimeout(this.chartResizeTimer);
    document.removeEventListener('mousedown', this.handleOverlayOutsideClick);
    if (this.menuScrollHandler) {
      document.removeEventListener('wheel', this.menuScrollHandler);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location && this.props.location && prevProps.location.pathname !== this.props.location.pathname) {
      if (this.props.navigationShown) this.props.toggleNavigationShown(false);
    }
    if (prevProps.navigationShown !== this.props.navigationShown) {
      document[this.props.navigationShown ? 'addEventListener' : 'removeEventListener']('mousedown', this.handleOverlayOutsideClick);
    }
    if (prevProps.navigationShown !== this.props.navigationShown || prevProps.navigationMenuOpened !== this.props.navigationMenuOpened) {
      clearTimeout(this.chartResizeTimer);
      this.chartResizeTimer = setTimeout(() => window.dispatchEvent(new Event('resize')), 350);
    }
    const accountLoaded = !!(this.props.user && this.props.user.permissions);
    const hasTeamDashboards = this.hasTeamDashboards();
    const dashboardId = this.dashboardId();
    if (
      prevProps.navigationShown !== this.props.navigationShown ||
      prevProps.navigationMenuOpened !== this.props.navigationMenuOpened ||
      (accountLoaded && (this.lastVisit.hasTeamDashboards !== hasTeamDashboards || this.lastVisit.dashboardId !== dashboardId))
    ) {
      if (accountLoaded) {
        this.lastVisit = { hasTeamDashboards, dashboardId };
      }
      try {
        window.localStorage.setItem('navigation', JSON.stringify({
          navigationShown: this.props.navigationShown,
          navigationMenuOpened: this.props.navigationMenuOpened,
          ...this.lastVisit,
        }));
      } catch (err) {}
    }
  }

  hasTeamDashboards() {
    const { user, dashboards } = this.props;
    if (!user || !user.permissions) return !!this.lastVisit.hasTeamDashboards;
    const { permissions } = user;
    return !!((permissions.manageDashboards || permissions.manageDashboardsViewOnly || permissions.dashboards && permissions.dashboards.length > 0) && dashboards);
  }

  dashboardId() {
    const { dashboard, user } = this.props;
    if (dashboard && dashboard._id) return dashboard._id;
    return (user && user.config && user.config.selectedDashboard) || this.lastVisit.dashboardId;
  }

  handleOverlayOutsideClick = e => {
    if (!e.target.closest('.navigation-inner, .btn-hamburger')) this.props.toggleNavigationShown(false);
  };

  renderLink(key, url, messageId, icon, end = false, label) {
    return (
      <Nav.Link key={key} as={NavLink} eventKey={key} to={url} end={end} aria-label={label ? translate(messageId) : undefined}>
        {icon && <img className='nav-icon' src={icon} alt='' />}
        <span className='nav-label'>{label || <FormattedMessage id={messageId} />}</span>
        {icon && (
          <OverlayTrigger placement="right"
            overlay={<Tooltip id={`nav-${key}`} className='tooltip_dark max-width-200 text-align-left'><FormattedMessage id={messageId} /></Tooltip>}>
            <span className="tooltip"></span>
          </OverlayTrigger>
        )}
      </Nav.Link>
    );
  }

  render() {
    const {
      showLinks,
      dashboard,
      user,
      toggleNavigationShown,
      navigationShown,
      toggleNavigationMenuOpened,
      navigationMenuOpened,
    } = this.props;
    const dashboardId = this.dashboardId();
    const phone = this.props.windowWidth <= PHONE_MAX_WIDTH;
    const autoRail = !phone && this.props.windowWidth <= RAIL_MAX_WIDTH;
    const collapsed = !phone && (autoRail ? !navigationShown : !navigationMenuOpened);
    const overlay = autoRail && navigationShown;
    const logoLink = (
      <Link className="logo" to={`${dashboard && dashboard._id ? `/dashboard/${dashboardId}/process` : '/'}`}>
        <img src={logo} alt="" />
      </Link>
    );
    const homeLogo = (
      <OverlayTrigger placement="right" overlay={<Tooltip id="nav-home" className='tooltip_dark'>Home</Tooltip>}>
        {logoLink}
      </OverlayTrigger>
    );
    const menuButton = (
      <Button id="hamburger-button" className='btn-hamburger' aria-label="Toggle navigation"
        onClick={() => (phone || autoRail ? toggleNavigationShown(!navigationShown) : toggleNavigationMenuOpened(!navigationMenuOpened))}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <path d="M4 7h16M4 12h16M4 17h10" />
        </svg>
      </Button>
    );
    const hasTeamDashboards = this.hasTeamDashboards();
    const menuKnown = !!(user && user.permissions) || this.lastVisit.hasTeamDashboards !== undefined;

    return (
      <div className={`navigation ${collapsed ? 'nav-main-close' : 'nav-main-open'} ${phone ? 'nav-phone' : ''} ${autoRail ? 'nav-auto-rail' : ''} ${overlay ? 'nav-overlay' : ''} ${!showLinks && 'no-show-link'}`} >
        <div className="navigation-inner">
          <div className='header_logo'>
            { this.props.outside ? (<img src={logo} alt="" />) :
            !showLinks ? (!phone && logoLink) :
            phone ? menuButton :
            collapsed ? homeLogo : (
              <React.Fragment>
                {logoLink}
                {menuButton}
              </React.Fragment>
            )}
          </div>
          <Navbar>
            <Container>
            {phone && navigationShown && <div className='nav-drawer-logo'>{logoLink}</div>}
            {collapsed && showLinks && <div className='nav-rail-control'>{menuButton}</div>}
            {/* the menu waits for the account, so its sections don't appear one after the other */}
            {showLinks && menuKnown &&
              <Nav className='menu'>
                {hasTeamDashboards && (
                  <React.Fragment>
                    <div className='nav-section'>{PERMISSIONS.dashboards.label}</div>
                    {this.renderLink('process', `/dashboard/${dashboardId}/process`, 'processImprovement', processImprovementIcon)}
                    {this.renderLink('overview', `/dashboard/${dashboardId}`, 'flowMetricsAndAnalytics', flowMetricsIcon, true)}
                    {CHARTS.map(chart =>
                      this.renderLink(chart.path, `/dashboard/${dashboardId}/${chart.path}`, chart.messageId, chart.icon, false, chart.label))}
                  </React.Fragment>
                )}
                <div className='nav-section'>Portfolio dashboards</div>
                {this.renderLink('report', '/report', 'exec_rep', valueStreamsIcon)}
                {this.renderLink('portfolios', '/portfolios', 'comp_rep', portfoliosIcon)}
              </Nav>
            }
            </Container>
          </Navbar>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleNavigationShown: show => dispatch(toggleNavigationShown(show)),
    toggleNavigationMenuOpened: opened => dispatch(toggleNavigationMenuOpened(opened)),
  };
};

function mapStateToProps(state) {
  const dashboards = state.dashboards.loaded ? state.dashboards.list.length : state.auth.user.dashboards;
  return {
    app: state.app.app,
    navigationShown: state.app.navigationShown,
    navigationMenuOpened: state.app.navigationMenuOpened,
    dashboard: state.dashboards.selected,    
    outside: state.app.outside,
    user: state.auth.user,
    dashboards,
  };
}

export default windowSize(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps, null, {
      pure: false
    })(Navigation)
  )
);
